<template>
  <div class="ResetPassswordView">
    <ResetPasswordComponent />
  </div>
</template>

<style scoped lang="scss">
  .ResetPassswordView {
    height: 100%;
  }
</style>

<script>
    import ResetPasswordComponent from '@/components/reset-password/ResetPasswordComponent.vue'

    export default {
        name: 'ResetPasswordView',
        components: {
            ResetPasswordComponent
        }
    }
</script>
